import { useLocation, Link  } from 'react-router-dom';
import { useContext,useEffect, useState } from 'react';
import axios from 'axios';
import DetailsContext from '../../providers/DetailsContext';
import NavBar from '../../components/layout/NavBar';
import NavBtn from '../../components/layout/NavBtn';
import language from '../../variables/language';
import NavTheme from '../../components/layout/NavTheme';
import NavPersonal from '../../components/layout/NavPersonal';
import AuthContext from '../../providers/AuthContext';
import NavOpenBtn from '../../components/layout/NavOpenBtn';
import { THEME_COLOR_KEYS, loadPaletteFromLocalStorage, persistPaletteToLocalStorage } from '../../variables/themeColorKeys';

//images
import iconUsers from '../../img/icon-users.svg';
import imgUserPersonal from '../../img/plant.png';
import iconMenuOpen from '../../img/icon-menu-open.svg';


export default function Layout({children}) {

   const [iconTheme , setIconTheme] = useState();
   const [lightPalette, setLightPalette] = useState(() => loadPaletteFromLocalStorage('light'));
   const [darkPalette, setDarkPalette] = useState(() => loadPaletteFromLocalStorage('dark'));
   // Bumped only when the server GET actually resolves - a distinct signal
   // from "the palettes changed" (which also happens on every local edit in
   // ThemeEditorPanel), so a consumer can tell "this is a fresh server sync"
   // apart from "the user just edited a color" without racing itself.
   const [themeSyncedAt, setThemeSyncedAt] = useState(0);

   const {firstName,setFirstName,lastName, setLastName} = useContext(AuthContext);
   const { theme ,setTheme, lang, setLang } = useContext(DetailsContext);
   const [navBar , setNavBar ] = useState( window.screen.width < 900? localStorage.getItem("nav-bar-open")==='true'?'0':'3' : localStorage.getItem("nav-bar-open")==='true'?'0':localStorage.getItem("nav-bar-open"));
   const [widthNav, setWidthNav] = useState('300px');
   const [widthText, setWidthText] = useState('fit-content');

   const location = useLocation();

    useEffect(() => {
      init();
    }, []);

   const init = () => {

      if(navBar==='1'){
         setWidthNav("300px");
         setWidthText("fit-content");
      }else if(navBar==='0'){
         setWidthNav("60px");
         setWidthText("0px");
      }else{
         setWidthNav("0px");
         setWidthText("0px");
      }
   }

   // Per-user palettes now come from the server (falls back to whatever's
   // already seeded in localStorage/the manifest defaults until that
   // resolves, so there's no flash-of-unstyled-colors on first paint).
   useEffect(() => {
      axios.get('/api/theme', { withCredentials: true }).then((response) => {
         // Merge rather than replace: a saved palette missing a key (e.g. an
         // older save from before a new color was added to the manifest)
         // must fall back to that key's current default, not to nothing.
         if (response.data.light) {
            setLightPalette((prev) => ({ ...prev, ...response.data.light }));
            persistPaletteToLocalStorage('light', response.data.light);
         }
         if (response.data.dark) {
            setDarkPalette((prev) => ({ ...prev, ...response.data.dark }));
            persistPaletteToLocalStorage('dark', response.data.dark);
         }
         setThemeSyncedAt(Date.now());
      }).catch(() => {});
   }, []);

   const saveThemeToServer = (light, dark) => {
      return axios.put('/api/theme', JSON.stringify({ light, dark }), {
         withCredentials: true,
         headers: { 'Content-Type': 'application/json' },
      });
   };

   // Mode switch only - the actual colors used within each mode now come
   // reactively from lightPalette/darkPalette (see the wrapper's inline
   // style below), not from values pushed imperatively here.
   const handlerTheme = () => {
      const next = theme === 'true' ? 'false' : 'true';
      setTheme(next);
      localStorage.setItem('theme', next);
   };

   const activePalette = theme === 'true' ? lightPalette : darkPalette;
   const themeStyle = {};
   THEME_COLOR_KEYS.forEach((entry) => { themeStyle[entry.cssVar] = activePalette[entry.key]; });
   const handlerNavBar = (e) => {
      e.stopPropagation();
      if(navBar==='1'){
         setNavBar('0');
         setWidthNav("60px");
         setWidthText("0px");
         localStorage.setItem('nav-bar-open', 0);
      }else {
         setNavBar('1');
         setWidthNav("300px");
         setWidthText("fit-content");
         localStorage.setItem('nav-bar-open', 1);
      }
   };
   const handlerOffNavBar = (e) => {
      e.stopPropagation();
      if(navBar!=='3'){
         setNavBar('3');
         setWidthNav("0px");
         setWidthText("0px");
         localStorage.setItem('nav-bar-open', 3);
      }else{
         setNavBar('0');
         setWidthNav("60px");
         setWidthText("0px");
         localStorage.setItem('nav-bar-open', 0);
      }
   };



   return (
      <div className='wrapper' style={
         {
            ...themeStyle,
            '--width-nav': widthNav ,
            '--nav-text-width': widthText ,
         }
         }>

         <NavBar className="nav-bar no-select"  >
            <NavOpenBtn path={iconMenuOpen} onClick={handlerNavBar} name="menu"/>

            <NavPersonal path={imgUserPersonal} firstName={firstName } lastName={lastName}/>

            <div className='nav-scroll'>
             <div className='nav-groups'>

               {/* Group 1: Панель / Конвеєр / Розклад */}
               <div className='nav-group'>
                  <Link  to='/dashboard'>
                     <NavBtn name={language[language.lang].dashboard} path={iconUsers} location={location.pathname.indexOf('dashboard') === -1 ? '' : 'focused'}>
                     <svg xmlns="http://www.w3.org/2000/svg" className='img-nav'  viewBox="0 -960 960 960" ><path d="M120-120v-80l80-80v160h-80Zm160 0v-240l80-80v320h-80Zm160 0v-320l80 81v239h-80Zm160 0v-239l80-80v319h-80Zm160 0v-400l80-80v480h-80ZM120-327v-113l280-280 160 160 280-280v113L560-447 400-607 120-327Z"/>
                     </svg>
                     </NavBtn>
                  </Link>
                  <Link  to='/pipeline'>
                     <NavBtn name={language[language.lang].pipeline} path={iconUsers} location={location.pathname.indexOf('pipeline') === -1 ? '' : 'focused'}>
                     <svg xmlns="http://www.w3.org/2000/svg" className='img-nav'  viewBox="0 -960 960 960" ><path d="M520-600v-240h320v240H520ZM120-440v-400h320v400H120Zm400 320v-400h320v400H520Zm-400 0v-240h320v240H120Zm80-400h160v-240H200v240Zm400 320h160v-240H600v240Zm0-480h160v-80H600v80ZM200-200h160v-80H200v80Zm160-320Zm240-160Zm0 240ZM360-280Z"/>
                     </svg>
                     </NavBtn>
                  </Link>
                  <Link  to='/schedule'>
                     <NavBtn name={language[language.lang].schedule} path={iconUsers} location={location.pathname.indexOf('schedule') === -1 ? '' : 'focused'}>
                     <svg xmlns="http://www.w3.org/2000/svg" className='img-nav'  viewBox="0 -960 960 960" ><path d="M200-80q-33 0-56.5-23.5T120-160v-560q0-33 23.5-56.5T200-800h40v-80h80v80h320v-80h80v80h40q33 0 56.5 23.5T840-720v560q0 33-23.5 56.5T760-80H200Zm0-80h560v-400H200v400Zm0-480h560v-80H200v80Zm0 0v-80 80Zm280 240q-17 0-28.5-11.5T440-440q0-17 11.5-28.5T480-480q17 0 28.5 11.5T520-440q0 17-11.5 28.5T480-400Zm-160 0q-17 0-28.5-11.5T280-440q0-17 11.5-28.5T320-480q17 0 28.5 11.5T360-440q0 17-11.5 28.5T320-400Zm320 0q-17 0-28.5-11.5T600-440q0-17 11.5-28.5T640-480q17 0 28.5 11.5T680-440q0 17-11.5 28.5T680-400ZM480-240q-17 0-28.5-11.5T440-280q0-17 11.5-28.5T480-320q17 0 28.5 11.5T520-280q0 17-11.5 28.5T480-240Zm-160 0q-17 0-28.5-11.5T280-280q0-17 11.5-28.5T320-320q17 0 28.5 11.5T360-280q0 17-11.5 28.5T320-240Zm320 0q-17 0-28.5-11.5T600-280q0-17 11.5-28.5T640-320q17 0 28.5 11.5T680-280q0 17-11.5 28.5T680-240Z"/>
                     </svg>
                     </NavBtn>
                  </Link>
               </div>

               {/* Group 2: Студенти / Клієнти / Групи */}
               <div className='nav-group'>
                  <Link  to='/students'>
                     <NavBtn name={language[language.lang].students} path={iconUsers} location={location.pathname.indexOf('students') === -1 ? '' : 'focused'}>
                     <svg xmlns="http://www.w3.org/2000/svg" className='img-nav' viewBox="0 -960 960 960" ><path d="M480-120 200-272v-240L40-600l440-240 440 240v320h-80v-276l-80 44v240L480-120Zm0-332 274-148-274-148-274 148 274 148Zm0 241 200-108v-151L480-360 280-470v151l200 108Zm0-241Zm0 90Zm0 0Z"/>
                     </svg>
                     </NavBtn>
                  </Link>
                  <Link  to='/clients'>
                     <NavBtn name={language[language.lang].clients} path={iconUsers} location={location.pathname.indexOf('clients') === -1 ? '' : 'focused'}>
                        <svg xmlns="http://www.w3.org/2000/svg" className='img-nav'  viewBox="0 -960 960 960" >
                           <path d="M40-160v-112q0-34 17.5-62.5T104-378q62-31 126-46.5T360-440q66 0 130 15.5T616-378q29 15 46.5 43.5T680-272v112H40Zm720 0v-120q0-44-24.5-84.5T666-434q51 6 96 20.5t84 35.5q36 20 55 44.5t19 53.5v120H760ZM360-480q-66 0-113-47t-47-113q0-66 47-113t113-47q66 0 113 47t47 113q0 66-47 113t-113 47Zm400-160q0 66-47 113t-113 47q-11 0-28-2.5t-28-5.5q27-32 41.5-71t14.5-81q0-42-14.5-81T544-792q14-5 28-6.5t28-1.5q66 0 113 47t47 113ZM120-240h480v-32q0-11-5.5-20T580-306q-54-27-109-40.5T360-360q-56 0-111 13.5T140-306q-9 5-14.5 14t-5.5 20v32Zm240-320q33 0 56.5-23.5T440-640q0-33-23.5-56.5T360-720q-33 0-56.5 23.5T280-640q0 33 23.5 56.5T360-560Zm0 320Zm0-400Z" />
                        </svg>
                     </NavBtn>
                  </Link>
                  <Link  to='/groups'>
                     <NavBtn name={language[language.lang].groups} path={iconUsers} location={location.pathname.indexOf('groups') === -1 ? '' : 'focused'}>
                     <svg xmlns="http://www.w3.org/2000/svg" className='img-nav' viewBox="0 -960 960 960" fill="#e8eaed"><path d="M411-480q-28 0-46-21t-13-49l12-72q8-43 40.5-70.5T480-720q44 0 76.5 27.5T597-622l12 72q5 28-13 49t-46 21H411Zm24-80h91l-8-49q-2-14-13-22.5t-25-8.5q-14 0-24.5 8.5T443-609l-8 49ZM124-441q-23 1-39.5-9T63-481q-2-9-1-18t5-17q0 1-1-4-2-2-10-24-2-12 3-23t13-19l2-2q2-19 15.5-32t33.5-13q3 0 19 4l3-1q5-5 13-7.5t17-2.5q11 0 19.5 3.5T208-626q1 0 1.5.5t1.5.5q14 1 24.5 8.5T251-596q2 7 1.5 13.5T250-570q0 1 1 4 7 7 11 15.5t4 17.5q0 4-6 21-1 2 0 4l2 16q0 21-17.5 36T202-441h-78Zm676 1q-33 0-56.5-23.5T720-520q0-12 3.5-22.5T733-563l-28-25q-10-8-3.5-20t18.5-12h80q33 0 56.5 23.5T880-540v20q0 33-23.5 56.5T800-440ZM0-240v-63q0-44 44.5-70.5T160-400q13 0 25 .5t23 2.5q-14 20-21 43t-7 49v65H0Zm240 0v-65q0-65 66.5-105T480-450q108 0 174 40t66 105v65H240Zm560-160q72 0 116 26.5t44 70.5v63H780v-65q0-26-6.5-49T754-397q11-2 22.5-2.5t23.5-.5Zm-320 30q-57 0-102 15t-53 35h311q-9-20-53.5-35T480-370Zm0 50Zm1-280Z"/>
                     </svg>
                     </NavBtn>
                  </Link>
               </div>

               {/* Group 3: Бот / Ігри */}
               <div className='nav-group'>
                  <Link  to='/conversations-menu'>
                     <NavBtn name={language[language.lang].conversations} path={iconUsers} location={location.pathname.indexOf('conversations') === -1 ? '' : 'focused'}>
                     <svg xmlns="http://www.w3.org/2000/svg" className='img-nav' viewBox="0 0 24 24" fill="#e8eaed"><path d="M0 0h24v24H0V0z" fill="none"/><g><rect fill="none" height="24" width="24" y="0"/></g><g><g><path d="M20,9V7c0-1.1-0.9-2-2-2h-3c0-1.66-1.34-3-3-3S9,3.34,9,5H6C4.9,5,4,5.9,4,7v2c-1.66,0-3,1.34-3,3s1.34,3,3,3v4 c0,1.1,0.9,2,2,2h12c1.1,0,2-0.9,2-2v-4c1.66,0,3-1.34,3-3S21.66,9,20,9z M18,19L6,19V7h12V19z M9,13c-0.83,0-1.5-0.67-1.5-1.5 S8.17,10,9,10s1.5,0.67,1.5,1.5S9.83,13,9,13z M16.5,11.5c0,0.83-0.67,1.5-1.5,1.5s-1.5-0.67-1.5-1.5S14.17,10,15,10 S16.5,10.67,16.5,11.5z M8,15h8v2H8V15z"/></g></g>
                     </svg>
                     </NavBtn>
                  </Link>
                  <Link  to='/games'>
                     <NavBtn name={language[language.lang].games} path={iconUsers} location={location.pathname.indexOf('games') === -1 ? '' : 'focused'}>
                     <svg xmlns="http://www.w3.org/2000/svg" className='img-nav'  viewBox="0 -960 960 960" ><path d="M182-200q-51 0-79-35.5T82-322l42-300q9-60 53.5-99T282-760h396q60 0 104.5 39t53.5 99l42 300q7 51-21 86.5T778-200q-21 0-39-7.5T706-230l-90-90H344l-90 90q-15 15-33 22.5t-39 7.5Zm16-86 114-114h336l114 114q2 2 16 6 11 0 17.5-6.5T800-304l-44-308q-4-29-26-48.5T678-680H282q-30 0-52 19.5T204-612l-44 308q-2 11 4.5 17.5T182-280q2 0 16-6Zm482-154q17 0 28.5-11.5T720-480q0-17-11.5-28.5T680-520q-17 0-28.5 11.5T640-480q0 17 11.5 28.5T680-440Zm-80-120q17 0 28.5-11.5T640-600q0-17-11.5-28.5T600-640q-17 0-28.5 11.5T560-600q0 17 11.5 28.5T600-560ZM310-440h60v-70h70v-60h-70v-70h-60v70h-70v60h70v70Zm170-40Z"/>
                     </svg>
                     </NavBtn>
                  </Link>
                  <Link  to='/exercise-templates'>
                     <NavBtn name='Вправи' path={iconUsers} location={location.pathname.indexOf('exercise-templates') === -1 ? '' : 'focused'}>
                     <svg xmlns="http://www.w3.org/2000/svg" className='img-nav' viewBox="0 -960 960 960"  ><path d="m826-585-56-56 30-31-128-128-31 30-57-57 30-31q23-23 57-22.5t57 23.5l129 129q23 23 23 56.5T857-615l-31 30ZM346-104q-23 23-56.5 23T233-104L104-233q-23-23-23-56.5t23-56.5l30-30 57 57-31 30 129 129 30-31 57 57-30 30Zm397-336 57-57-303-303-57 57 303 303ZM463-160l57-58-302-302-58 57 303 303Zm-6-234 110-109-64-64-109 110 63 63Zm63 290q-23 23-57 23t-57-23L104-406q-23-23-23-57t23-57l57-57q23-23 56.5-23t56.5 23l63 63 110-110-63-62q-23-23-23-57t23-57l57-57q23-23 56.5-23t56.5 23l303 303q23 23 23 56.5T857-441l-57 57q-23 23-57 23t-57-23l-62-63-110 110 63 63q23 23 23 56.5T577-161l-57 57Z"/>
                     </svg>
                     </NavBtn>
                  </Link>
                  <Link  to='/courses'>
                     <NavBtn name='Курси' path={iconUsers} location={location.pathname.indexOf('courses') === -1 ? '' : 'focused'}>
                     <svg xmlns="http://www.w3.org/2000/svg" className='img-nav'  viewBox="0 -960 960 960" ><path d="M480-160q-51-39-114-59.5T240-240q-64 0-124.5 20.5T5-160v-500q54-33 114.5-46.5T240-720q73 0 141.5 21.5T480-640q69-37 137.5-58.5T759-720q65 0 125.5 13.5T999-660v500q-60-24-120.5-42T759-220q-73 0-136 20.5T480-160Zm40-90q56-30 117-45t123-15q31 0 61 4t59 11v-380q-29-10-59.5-15t-60.5-5q-62 0-121.5 17T520-630v380Zm-320 20q59-15 116-19t124 4v-380q-52-19-112-27.5T120-660v420Zm320-20v-380q56-33 116.5-49.5T757-696q-3 3 0 0v-24q-59-13-118.5-13T520-700v450Zm-320-380v380-380Zm320-70v380-380Z"/>
                     </svg>
                     </NavBtn>
                  </Link>
                  <Link  to='/communications'>
                     <NavBtn name='Повідомлення' path={iconUsers} location={location.pathname.indexOf('communications') === -1 ? '' : 'focused'}>
                     <svg xmlns="http://www.w3.org/2000/svg" className='img-nav'  viewBox="0 -960 960 960"  ><path d="M720-440v-80h160v80H720Zm48 280-128-96 48-64 128 96-48 64Zm-80-480-48-64 128-96 48 64-128 96ZM200-200v-160h-40q-33 0-56.5-23.5T80-440v-80q0-33 23.5-56.5T160-600h160l200-120v480L320-360h-40v160h-80Zm240-182v-196l-98 58H160v80h182l98 58Zm120 36v-268q27 24 43.5 58.5T620-480q0 41-16.5 75.5T560-346ZM300-480Z"/>
                     </svg>
                     </NavBtn>
                  </Link>
               </div>

               {/* Group 4: Користувачі / Проєкти / Налаштування */}
               <div className='nav-group'>
                  <Link  to='/users'>
                     <NavBtn name={language[language.lang].users} path={iconUsers} location={location.pathname.indexOf('users') === -1 ? '' : 'focused'}>
                     <svg xmlns="http://www.w3.org/2000/svg" className='img-nav'  viewBox="0 -960 960 960" ><path d="M160-80q-33 0-56.5-23.5T80-160v-440q0-33 23.5-56.5T160-680h200v-120q0-33 23.5-56.5T440-880h80q33 0 56.5 23.5T600-800v120h200q33 0 56.5 23.5T880-600v440q0 33-23.5 56.5T800-80H160Zm0-80h640v-440H600q0 33-23.5 56.5T520-520h-80q-33 0-56.5-23.5T360-600H160v440Zm80-80h240v-18q0-17-9.5-31.5T444-312q-20-9-40.5-13.5T360-330q-23 0-43.5 4.5T276-312q-17 8-26.5 22.5T240-258v18Zm320-60h160v-60H560v60Zm-200-60q25 0 42.5-17.5T420-420q0-25-17.5-42.5T360-480q-25 0-42.5 17.5T300-420q0 25 17.5 42.5T360-360Zm200-60h160v-60H560v60ZM440-600h80v-200h-80v200Zm40 220Z"/>
                     </svg>
                     </NavBtn>
                  </Link>
                  <Link  to='/projects'>
                     <NavBtn name={language[language.lang].projects} path={iconUsers} location={location.pathname.indexOf('projects') === -1 ? '' : 'focused'}>
                     <svg xmlns="http://www.w3.org/2000/svg" className='img-nav'viewBox="0 -960 960 960" ><path d="m260-520 220-360 220 360H260ZM700-80q-75 0-127.5-52.5T520-260q0-75 52.5-127.5T700-440q75 0 127.5 52.5T880-260q0 75-52.5 127.5T700-80Zm-580-20v-320h320v320H120Zm580-60q42 0 71-29t29-71q0-42-29-71t-71-29q-42 0-71 29t-29 71q0 42 29 71t71 29Zm-500-20h160v-160H200v160Zm202-420h156l-78-126-78 126Zm78 0ZM360-340Zm340 80Z"/>
                     </svg>
                     </NavBtn>
                  </Link>
                  <Link  to='/settings'>
                     <NavBtn name={language[language.lang].settings} path={iconUsers} location={location.pathname.indexOf('settings') === -1 ? '' : 'focused'}>
                     <svg xmlns="http://www.w3.org/2000/svg"  className='img-nav' viewBox="0 -960 960 960" ><path d="m234-480-12-60q-12-5-22.5-10.5T178-564l-58 18-40-68 46-40q-2-13-2-26t2-26l-46-40 40-68 58 18q11-8 21.5-13.5T222-820l12-60h80l12 60q12 5 22.5 10.5T370-796l58-18 40 68-46 40q2 13 2 26t-2 26l46 40-40 68-58-18q-11 8-21.5 13.5T326-540l-12 60h-80Zm40-120q33 0 56.5-23.5T354-680q0-33-23.5-56.5T274-760q-33 0-56.5 23.5T194-680q0 33 23.5 56.5T274-600ZM592-40l-18-84q-17-6-31.5-14.5T514-158l-80 26-56-96 64-56q-2-18-2-36t2-36l-64-56 56-96 80 26q14-11 28.5-19.5T574-516l18-84h112l18 84q17 6 31.5 14.5T782-482l80-26 56 96-64 56q2 18 2 36t-2 36l64 56-56 96-80-26q-14 11-28.5 19.5T722-124l-18 84H592Zm56-160q50 0 85-35t35-85q0-50-35-85t-85-35q-50 0-85 35t-35 85q0 50 35 85t85 35Z"/>
                     </svg>
                     </NavBtn>
                  </Link>
               </div>

               {/* Login: separated from the module groups, sits further below */}
               <div className='nav-group nav-group-logout'>
                  <Link  to='/logout'>
                     <NavBtn name={language[language.lang].logout} path={iconUsers} location={location.pathname.indexOf('logout') === -1 ? '' : 'focused'}>
                     <svg xmlns="http://www.w3.org/2000/svg" className='img-nav'  viewBox="0 -960 960 960" ><path d="M200-120q-33 0-56.5-23.5T120-200v-560q0-33 23.5-56.5T200-840h280v80H200v560h280v80H200Zm440-160-55-58 102-102H360v-80h327L585-622l55-58 200 200-200 200Z"/>
                     </svg>
                     </NavBtn>
                  </Link>
               </div>

             </div>
            </div>

            <NavTheme onClick={handlerTheme} path={iconUsers} isLight={theme} />
         </NavBar>
         <div className='hide-nav-btn' onClick={handlerOffNavBar} style={{position:'fixed', right:-50, bottom:40, width:100, height:100,
          borderRadius: `50% 0 0 50%`,backdropFilter:`blur(2px)` }} ></div>
         <div className='wrap-container'   style={{minWidth:'available',width:"available",}}>
            <DetailsContext.Provider value={{ theme, setTheme, lang, setLang, lightPalette, setLightPalette, darkPalette, setDarkPalette, saveThemeToServer, themeSyncedAt }}>
               {children}
            </DetailsContext.Provider>
         </div>

      </div>
   );
 }
